import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function RequireAuth() {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return <div className="min-h-screen bg-gray-100 dark:bg-gray-900" />;
  }
  if (!user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`;
    return <Navigate to={`/login?return=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <Outlet />;
}
